// Очередь ходов с клавиатуры. Зажатая стрелка даёт десятки keydown, а каждая запись должна
// считаться на подтверждённой строке — иначе ложный conflict. Ходы копятся, пока запись в полёте,
// и уходят одним суммарным ходом. Чистая модель без React и без записи.

export type KeyMove = { days: number; rows: number; grow: number };

const ZERO: KeyMove = { days: 0, rows: 0, grow: 0 };
export const isIdle = (m: KeyMove): boolean => m.days === 0 && m.rows === 0 && m.grow === 0;

/** Стрелка → ход: по неделям, с Ctrl — по дням; Shift с ← → — растяжение; не стрелка — null. */
export function arrowMove(key: string, mods: { ctrl: boolean; shift: boolean }): KeyMove | null {
  const arrows: Record<string, [number, number]> = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
  const a = arrows[key];
  if (!a) return null;
  const step = mods.ctrl ? 1 : 7;
  if (mods.shift && a[0] !== 0) return { days: 0, rows: 0, grow: a[0] * step };
  return { days: a[0] * step, rows: a[1], grow: 0 };
}

type Entry<C> = { pending: KeyMove; running: boolean; ctx: C };

/** Очередь на задачу: push копит, take забирает накопленное и обнуляет; ctx — что экран помнит между ходами. */
export class MoveQueue<C> {
  private readonly q = new Map<string, Entry<C>>();

  /** Добавить ход. ctx обновляется, только если запись не в полёте: иначе контекст задаёт результат прошлого хода. */
  push(taskId: string, move: KeyMove, ctx: C): void {
    const e = this.q.get(taskId) ?? { pending: ZERO, running: false, ctx };
    if (!e.running) e.ctx = ctx;
    e.pending = { days: e.pending.days + move.days, rows: e.pending.rows + move.rows, grow: e.pending.grow + move.grow };
    this.q.set(taskId, e);
  }

  /** Забрать накопленное одним ходом; null — нечего. */
  take(taskId: string): KeyMove | null {
    const e = this.q.get(taskId);
    if (!e || isIdle(e.pending)) return null;
    const m = e.pending;
    e.pending = ZERO;
    return m;
  }

  ctx(taskId: string): C | undefined { return this.q.get(taskId)?.ctx; }
  setCtx(taskId: string, ctx: C): void { const e = this.q.get(taskId); if (e) e.ctx = ctx; }
  isRunning(taskId: string): boolean { return this.q.get(taskId)?.running ?? false; }
  setRunning(taskId: string, running: boolean): void { const e = this.q.get(taskId); if (e) e.running = running; }
}
